import { useCallback } from 'react';
import { TextFieldOne } from '../../TextFieldOne/TextFieldOne.component';
import { TextFieldProps } from '@mui/material';

interface InputTextFieldProps<T> {
  idRow: string | number;
  value: T;
  rowKey: keyof T;
  isValid: boolean;
  handleValueChange: (type: keyof T, value: number | boolean | null, id: string | number) => void;
  validation?: (row: T, key: keyof T) => boolean;
  decimal?: number;
  isText?: boolean;
  inputLabel?: string;
  ariaLabel?: string;
}

type InputTextFieldPropsExtended<T> = InputTextFieldProps<T> & TextFieldProps;

export const InputTextField = <T,>(props: InputTextFieldPropsExtended<T>) => {
  const InputTextFieldProps = ['idRow', 'rowKey', 'validation', 'isValid', 'handleValueChange', 'decimal', 'isText'];
  const filterProps = Object.entries(props).filter((x) => !InputTextFieldProps.includes(x[0]));
  const convertedProps = Object.fromEntries(filterProps);

  const onValueChange = useCallback(
    (fieldValue: string) => {
      const val =
        !isNaN(+fieldValue) && fieldValue
          ? Boolean(props.decimal)
            ? +parseFloat(fieldValue).toFixed(props.decimal)
            : parseInt(fieldValue, 10)
          : null;
      const rowValue: T = { ...props.value, [props.rowKey]: val };

      props.handleValueChange(props.rowKey, val, props.idRow);
      if (props.validation) {
        props.validation(rowValue, props.rowKey);
      }
    },
    [props.key, props.value, props.handleValueChange],
  );

  return (
    <TextFieldOne
      {...convertedProps}
      area-label={props.ariaLabel}
      id="outlined-number"
      label={props.inputLabel}
      value={props.value[props.rowKey] ?? ''}
      onChange={(e) => onValueChange(e.target.value)}
      error={props.isValid}
    />
  );
};
